import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import Lang from '/@/modules/core/app/services/Lang';

export class StripeTaxRate extends BaseModel {
  public id: string;

  public displayName: string;

  public percentage: number;

  constructor(model: Partial<StripeTaxRate> = {}) {
    super();

    this.id = model.id as string;
    this.displayName = model.displayName as string;
    this.percentage = model.percentage as number;
  }

  get translatedDisplayName(): string {
    return this.translatedDisplayNamesObject[this.displayName] ?? Lang.t(this.displayName);
  }

  get translatedPercentage(): string {
    return Lang.number(this.percentage);
  }

  get translatedDisplayNamesObject(): Record<string, string> {
    return {
      GST: Lang.t('billing.gst'),
      QST: Lang.t('billing.tvq'),
      HST: Lang.t('billing.hst')
    };
  }
}
